import { render, staticRenderFns } from "./Commerciale.vue?vue&type=template&id=cd5a818a&scoped=true&"
import script from "./Commerciale.vue?vue&type=script&lang=js&"
export * from "./Commerciale.vue?vue&type=script&lang=js&"
import style0 from "./Commerciale.vue?vue&type=style&index=0&id=cd5a818a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5a818a",
  null
  
)

export default component.exports